module.exports = __webpack_public_path__ + "static/img/menu2.57f67807.png";